<template>
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="16.26"
		height="15.503"
		viewBox="0 0 16.26 15.503"
	>
		<defs id="star-defs">
			<linearGradient :id="id">
				<stop offset="100%" stop-color="currentColor" />
			</linearGradient>
			<linearGradient :id="id">
				<stop :offset="`${percentage}%`" :stop-color="activeColor" />
				<stop offset="0%" stop-color="transparent" stop-opacity="0" />
			</linearGradient>
		</defs>
		<path
			id="Path_1537"
			:fill="`url(#${id})`"
			data-name="Path 1537"
			d="M23.664,15.224a.478.478,0,0,0-.372-.19l-5.428-.109L16.082,9.8a.479.479,0,0,0-.9,0L13.4,14.925l-5.428.109a.478.478,0,0,0-.279.859l4.325,3.278-1.574,5.192a.478.478,0,0,0,.734.531l4.455-3.1,4.455,3.1a.478.478,0,0,0,.73-.531l-1.57-5.192,4.325-3.278A.478.478,0,0,0,23.664,15.224Z"
			transform="translate(-7.5 -9.48)"
		/>
		<path
			id="Path_1537"
			:fill="`url(#${id})`"
			data-name="Path 1537"
			d="M23.664,15.224a.478.478,0,0,0-.372-.19l-5.428-.109L16.082,9.8a.479.479,0,0,0-.9,0L13.4,14.925l-5.428.109a.478.478,0,0,0-.279.859l4.325,3.278-1.574,5.192a.478.478,0,0,0,.734.531l4.455-3.1,4.455,3.1a.478.478,0,0,0,.73-.531l-1.57-5.192,4.325-3.278A.478.478,0,0,0,23.664,15.224Z"
			transform="translate(-7.5 -9.48)"
		/>
	</svg>
</template>

<script setup>
const props = defineProps({
	percentage: {
		type: Number,
		default: 100,
		required: false,
	},
	activeColor: {
		type: String,
		default: '#ffab39',
		required: false,
	},
})

const id = useId()
</script>
